import { OrderStatisticsDto } from '../api-types/models/OrderStatisticsDto';

export function isEmptyStatistics(statistics: OrderStatisticsDto) {
    return statistics.completed === 0;
}
